import BarChart from './BarChart.jsx';

function IncomeChart({ data }) {
  const options = {
    xaxis: {
      categories: [
        '16-24 года',
        '25-34 года',
        '35-44 года',
        '45-54 года',
        '55-64 года',
        '65+ лет',
      ],
    },
  };

  return (
    <BarChart
      series={data}
      options={options}
      title="Доходы населения по полу и возрасту, тенге"
    />
  );
}

export default IncomeChart;
